import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>CarWrap Artist</h3>
          <p>Professional car wrapping and custom design.</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            {/* <li><Link to="/shop">Shop</Link></li> */}
            <li><Link to="/team">Team</Link></li>
            <li><Link to="/vacatures">Vacatures</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p>Email: info@carwrapartist.be</p>
          <p>Phone: +32 468 45 70 05</p>
          <p>BTW Nummer: BE0759942144</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} CarWrap Artist. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
